import React, { useState, useEffect } from 'react';
import { useQueryClient } from 'react-query';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTextField from '@material-ui/core/TextField';
import RowButtons from './RowButtons';

const SubtableRow = ({ fee, platformFeeEditId, setPlatformFeeEditId, patchPlatformFeeMutation, register }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [wasSuccessful, setWasSuccessful] = useState(false);

  const queryClient = useQueryClient();

  const mutationCache = queryClient.getMutationCache();
  mutationCache.subscribe(({ state }) => {
    if (state?.data?.id === fee.id && state?.status === 'success') {
      setWasSuccessful(true);
    }
  });

  useEffect(() => {
    setIsEditing(fee.id === platformFeeEditId && !wasSuccessful);
  }, [fee, platformFeeEditId, wasSuccessful, setIsEditing]);

  const resetSubmitState = () => {
    patchPlatformFeeMutation.reset();
    setPlatformFeeEditId(fee.id);
    setWasSuccessful(false);
  };

  return (
    <MuiTableRow>
      <MuiTableCell style={{ width: '5%' }} component="th" scope="row">
        {fee.id}
      </MuiTableCell>
      <MuiTableCell style={{ width: '15%' }}>
        {isEditing ? (
          <MuiTextField
            variant="outlined"
            label={fee.percentage}
            defaultValue={fee.percentage}
            placeholder={fee.percentage}
            size="small"
            type="text"
            name="percentage"
            inputRef={register()}
          />
        ) : (
          fee.percentage
        )}
      </MuiTableCell>
      <MuiTableCell style={{ width: '20%' }}>
        {isEditing ? (
          <MuiTextField
            variant="outlined"
            label={fee.effective_date_range.start_inclusive}
            placeholder={fee.effective_date_range.start_inclusive}
            defaultValue={fee.effective_date_range.start_inclusive}
            size="small"
            type="text"
            name="startInclusive"
            inputRef={register()}
          />
        ) : (
          fee.effective_date_range.start_inclusive
        )}
      </MuiTableCell>
      <MuiTableCell style={{ width: '20%' }}>
        {isEditing ? (
          <MuiTextField
            variant="outlined"
            label={fee.effective_date_range.end_inclusive}
            size="small"
            type="text"
            placeholder={fee.effective_date_range.end_inclusive}
            defaultValue={fee.effective_date_range.end_inclusive}
            name="endInclusive"
            inputRef={register()}
          />
        ) : (
          fee.effective_date_range.end_inclusive
        )}
      </MuiTableCell>
      <MuiTableCell align="right">
        <RowButtons
          isEditing={isEditing}
          setPlatformFeeEditId={setPlatformFeeEditId}
          isSuccess={patchPlatformFeeMutation.isSuccess && fee.id === patchPlatformFeeMutation.data.id}
          isLoading={patchPlatformFeeMutation.isLoading && fee.id === patchPlatformFeeMutation?.data?.id}
          isError={patchPlatformFeeMutation.isError}
          resetSubmitState={resetSubmitState}
          feeId={fee.id}
        />
      </MuiTableCell>
    </MuiTableRow>
  );
};

export default SubtableRow;
